module.exports = __webpack_public_path__ + "assets/img/29_201.fe7fd424.jpg";